import { Box } from "@mui/material";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import React, { Fragment, useEffect } from "react";
import NavbarComponent from "../components/navbar/NavbarComponent";
import { ApiErrorModal } from "../errorHandling/ApiErrorModal";
import HeaderComponent from "../components/header/HeaderComponent";
import Dashboard from "../pages/Dashboard/Dashboard";
import styles from "./routeComponent.module.scss";
import Dealers from "../pages/Dealers/Dealers";
import Vehicles from "../pages/Vehicles/Vehicles";
import DealerExport from "../pages/Exports/DealerExport";
import VehicleExport from "../pages/Exports/VehicleExport";
import Report from "../pages/Report/Report";
import SettingsPage from "../pages/Settings/SettingsPage";
import ExactFrame from "../pages/Exact/ExactFrame";
import queryString from "query-string";
import _ from "lodash";
import Login from "../pages/Login/Login";
import { useAuth } from "../auth/AuthContext";

const RequireAuth = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate replace to="/login" />;
  }

  return children;
};

const Logout = () => {
  const { logout } = useAuth();

  useEffect(() => {
    logout();
  }, [logout]);

  return <Navigate replace to="/login" />;
};

export default function RouteComponent() {
  const queries = queryString.parse(window?.location?.search);
  let exactTokenCode = _.get(queries, "code", null);
  const { isAuthenticated } = useAuth();
  return (
    <Router>
      <Fragment>
        {isAuthenticated ? <HeaderComponent /> : null}
        {isAuthenticated && _.isNull(exactTokenCode) ? <NavbarComponent /> : null}

        <ApiErrorModal />
      </Fragment>

      <Box
        className={isAuthenticated ? styles.contentMainWrapper : undefined}
        id="contentWrapper"
      >
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/.auth/login" element={<Navigate replace to="/" />} />

          <Route exact path="/" element={<RequireAuth><Dashboard /></RequireAuth>} />
          <Route exact path="/dealers" element={<RequireAuth><Dealers /></RequireAuth>} />
          <Route exact path="/vehicles" element={<RequireAuth><Vehicles /></RequireAuth>} />
          <Route exact path="settings" element={<RequireAuth><SettingsPage /></RequireAuth>} />
          <Route exact path="/export_dealers" element={<RequireAuth><DealerExport /></RequireAuth>} />
          <Route
            exact
            path="/export_vehicle_lists"
            element={<RequireAuth><VehicleExport /></RequireAuth>}
          />
          <Route exact path="/reports" element={<RequireAuth><Report /></RequireAuth>} />
          <Route path="/exact" element={<RequireAuth><ExactFrame /></RequireAuth>} />

          <Route path="/logout" element={<Logout />} />
        </Routes>
      </Box>
    </Router>
  );
}
